import { FOI_RESPONSE_TAB_QUERY_VALUES } from './consts'

export function openFoiBillInNewWindow(foiId, billId) {
  if (!foiId) return
  const params = new URLSearchParams()
  params.set('tab', FOI_RESPONSE_TAB_QUERY_VALUES.billing)
  if (billId) params.set('billId', billId)
  window.open(`/foi/${foiId}?${params.toString()}`, '_blank', 'noopener,noreferrer')
}

export function openFoiLetterInNewWindow(foiId, letterId) {
  if (!foiId) return
  const params = new URLSearchParams()
  params.set('tab', FOI_RESPONSE_TAB_QUERY_VALUES.letters)
  if (letterId) params.set('letterId', letterId)
  window.open(`/foi/${foiId}?${params.toString()}`, '_blank', 'noopener,noreferrer')
}

export function openFoiCommunicationInNewWindow(foiId, communicationId) {
  if (!foiId) return
  const params = new URLSearchParams()
  params.set('tab', FOI_RESPONSE_TAB_QUERY_VALUES.communications)
  if (communicationId) params.set('communicationId', communicationId)
  window.open(`/foi/${foiId}?${params.toString()}`, '_blank', 'noopener,noreferrer')
}
